import Layout from "@/views/layout/index";

export const FILESIGN = [
    {
        path: '/SIGN',
        component: Layout,
        redirect: '/SIGN/fileSign',
        name: '图框文件签名',
        menuName: '图框文件签名',
        meta: {
            title: "图框文件签名",
            icon: "el-icon-c-scale-to-original",
        },
        children: [
            {
                path: 'fileSign',
                component: () => import('@/views/pictureFrameFileSignature/FileSignature'),
                name: '图框文件签名',
                menuName: '图框文件签名',
                meta: {title: "图框文件签名"}
            },
        ]
    },
];
